import { createFileRoute, redirect } from '@tanstack/react-router';

import { legacySettingsSearch, validateLegacyTeamSearch } from '@/pages/settings/settings-tabs';

/**
 * The standalone Policy Center is gone — policies now live in Team
 * Settings → Policies (full editor inline).  This route redirects any
 * old `/policies` link there (keeping `?team=`).
 */
export const Route = createFileRoute('/policies')({
  validateSearch: validateLegacyTeamSearch,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/settings', search: legacySettingsSearch('policies', search) });
  },
});
